<template>
  <div class="page-publicList page-back">
    <div class="page-width">
      <div class="publicList-content">
        <div class="list-box">
          <div
            v-for="(item, index) in publicList"
            :key="item.id + index"
            class="content-row"
            @click="hanleRow(item)"
          >
            <span class="row-point"></span>
            <div class="row-content">
              <span class="title" v-html="item.name" />
              <span class="time" v-if="item.publishTime">{{
                item.publishTime.slice(0, 10)
              }}</span>
            </div>
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleLimitChange"
            @current-change="handlePageChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTalentServeListPage } from '@/api/talentService'

export default {
  name: 'PublicInformationList',

  data() {
    return {
      total: 0,
      page: 1,
      limit: 10,
      publicList: []
    }
  },
  created() {
    this.getPublicList()
  },
  methods: {
    async getPublicList() {
      try {
        const { page, limit } = this
        const params = {
          page,
          limit,
          type: 4
        }
        const res = await getTalentServeListPage(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.publicList = records
          this.total = Number(total)
        }
      } catch (error) {}
    },
    handleLimitChange(limit) {
      this.page = 1
      this.limit = limit
      this.getPublicList()
    },
    handlePageChange(page) {
      this.page = page
      this.getPublicList()
    },
    hanleRow(row) {
      const { id } = row
      this.$router.push({
        path: '/talentServiceDetail',
        query: { id, rePath: '/talentService?id=4', reLabel: '相关政策及材料下载' }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-back {
  background-color: #fff !important;
}
.page-publicList {
  padding: 28px 0 88px 0;
  background: #eef3ff;
  .page-width {
    width: 100% !important;
  }
  > div {
    width: 1300px;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 20px;
    .publicList-content {
      box-sizing: border-box;
      margin: 0 30px;
      height: 620px;
      border: 2px solid #0753b6;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .list-box {
        width: 100%;
        flex: 1;
        overflow: auto;
        .content-row {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          position: relative;
          .row-point {
            position: absolute;
            top: 8px;
            width: 4px;
            height: 4px;
            background: #ff4e4e;
            border-radius: 50%;
            margin: 0 13px 0 23px;
          }
          .row-content {
            flex: 1;
            margin-right: 36px;
            border-bottom: 1px dashed #c6c6c6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 10px;
            padding-left: 36px;
            .title {
              flex: 1;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
            .time {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
            }
          }
        }
      }
      .pagination-box {
        padding: 10px;
      }
    }
  }
}
</style>
